import { authHandler } from "./auth.mock";

const authHandlers = [...authHandler];

export default authHandlers;
